import React, { useRef, useState } from "react";
import { Autocomplete, Box, TextField, InputAdornment, Checkbox, Divider } from "@mui/material";
import { idGenerator } from "helpers/createId";
import { orderArrayV2 } from "helpers/orderArray";

export const AutocompleteComponent = (props) => {
  const {
    options = [],
    search = "",
    name,
    value,
    loading,
    label,

    disabled,
    size = "large",
    onAction = null,
    align = "left",

    sort = false,

    multiple = false,
    enableSelectAll = false,
    allLabel = 'Todas las opciones',
    limitTags = 1,
    customAction = null,
    handleValues,
    textFieldProps = {},
    keyOption = "id",
    optionsOpen = false,
    ...rest
  } = props;
  const idRef = useRef(`${search}-${idGenerator()}`);
  const componentId = `autocomplete-component-id-${idRef.current}`;
  const isAll = multiple && value?.length === options.length;

  const computedOptions =
    enableSelectAll && multiple && options.length
      ? [{ value: 'ALL', label: allLabel }, ...options]
      : options;

  return (
    <Autocomplete
      {...rest}
      id={componentId}
      multiple={multiple}
      disableCloseOnSelect={enableSelectAll}
      options={sort ? orderArrayV2(computedOptions) : computedOptions}
      value={value || (multiple ? [] : null)}
      isOptionEqualToValue={(option, value) => {
        if (!value) return true;
        return (
          (option[keyOption] || option.value) ===
          (value[keyOption] || value.value)
        );
      }}
      getOptionKey={(option) => option[keyOption] || option.value}
      getOptionLabel={(option) => option.label || option.name || ""}
      renderInput={(params) => (
        <Box sx={{ position: "relative" }}>
          <TextField
            {...params}
            label={label}
            variant="outlined"
            {...textFieldProps}
            InputProps={{
              ...params.InputProps,
              ...textFieldProps?.InputProps,
              style: { textAlign: align },
              inputProps: {
                ...params.inputProps,
                ...textFieldProps?.inputProps,
                style: { textAlign: align },
              },
              endAdornment: (
                <>
                  {params.InputProps.endAdornment}
                  <InputAdornment position="end">{onAction}</InputAdornment>
                </>
              ),
            }}
          />
        </Box>
      )}
      fullWidth
      size={size}
      loading={loading}
      disabled={disabled}
      onChange={(_, v) => {
        if (!multiple) {
          return customAction
            ? customAction(v, _)
            : handleValues({ [name]: v });
        }

        const filteredValues = v.filter((opt) => opt.value !== "ALL");

        handleValues({ [name]: filteredValues });
      }}
      noOptionsText={loading ? "Cargando..." : "No hay resultados"}
      limitTags={limitTags}
      renderOption={(props, option) => {
        if (enableSelectAll && option.value === 'ALL') {
          return (
            <>
              <Box pl={1.5} py={0.5}>
                <Checkbox
                  checked={isAll}
                  onMouseDown={(e) => e.preventDefault()}
                  onChange={() => {
                    const newValue = isAll ? [] : options;
                    handleValues({ [name]: newValue });
                  }}
                />
                {allLabel}
              </Box>
              <Divider />
            </>
          );
        }

        const { key, ...optionProps } = props;
        return (
          <Box component="li" key={key} {...optionProps}>
            {option.label || option.name}
          </Box>
        );
      }}
    />
  );
};
